import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import { Button } from 'reactstrap'
import SearchIcon from "../../../../../../../static/images/search_icon.svg"
import { FONTS } from '../../../../../../../constants'

export const ResourceUtilButton = class extends React.Component {
  render() {
    const handleSearchResource = get(this.props, 'handleSearchResource')
    const exportEfficiencyLOB = get(this.props, 'exportEfficiencyLOB')
    return (
      <Buttons>
        <Wrapper>
          <Circle color='#B5E8B5' />
          <span>0.70 - 1.00</span>
        </Wrapper>
        <Wrapper>
          <Circle color='#F8DAAF' />
          <span>less than 0.70</span>
        </Wrapper>
        <Wrapper>
          <Circle color='#ECADAD' />
          <span>more than 1.00</span>
        </Wrapper>
        <SearchField
          placeholder='Search by employee'
          onChange={ (e) => {
            if (e.target.value === '') handleSearchResource(e.target.value)
            this.setState({ tempSearch: e.target.value })
          } }
          onKeyDown={ (e) => {
            if (e.keyCode === 13) handleSearchResource(this.state.tempSearch)
          } }
        />
        <ExportButton onClick={ () => exportEfficiencyLOB() }>
        Export
        </ExportButton>
      </Buttons>
    )
  }
}

const Buttons = styled.div`
  width: 50%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  position: absolute;
  right: 20px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
`
const ExportButton = styled(Button)`
  height: 30px;
  width: 70px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
  background: #428BCA;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
const SearchField = styled.input`
  height: 30px;
  width: 30%;
  padding-left: 30px;
  background: url(${SearchIcon}) no-repeat scroll 10px;
  background-size: 15px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-left: 1% !important;
  margin-right: 1% !important;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  z-index: 999 !important;
  ::placeholder {
    color: #CCCCCC;
  }
`
const Circle = styled.span`
  font-size: 10px;
  text-align: center;
  height: 15px;
  width: 15px;
  background-color: ${props => props.color};
  border-radius: 50%;
  border: 1px solid #A1A1A1;
  margin-right: 10px;
  margin-left: 10px;
  cursor: default;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-overview/detail/tab/button-group/resource-utilization.js